import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  IN_ROOM_DINING_MENU_CREATE,
  IN_ROOM_DINING_MENU_CREATE_TYPE,
  IN_ROOM_DINING_MENU_INFO_VIEW,
  IN_ROOM_DINING_MENU_VIEW,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import {
  inRoomDiningMenuSelector,
  fetchAllInRoomDiningMenu,
  setInRoomDiningMenu,
} from '../../../servicesSlice';
import InRoomDiningMenuListTable from './Menu-List-Table';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import {
  activeInRoomDiningMenu,
  deactiveInRoomDiningMenu,
  deleteInRoomDiningMenu,
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { useDispatch } from 'react-redux';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import { isEmpty } from 'lodash';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import {
  ResetFilterList,
  selectedCheckList,
  getCheckedIds,
  updateCheckedStatus,
  isDragDisabled,
} from '../../../../../utils/formUtils';
import { generatePublishedMessage } from '../../../../../utils/formUtils';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const InRoomDiningMenuList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    inRoomDiningLoader,
    hotelId,
    restaurantId,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    isHideAddButton = false,
  } = props;
  const inRoomDiningMenu = useSelector(inRoomDiningMenuSelector);
  const [menuList, setMenuList] = useState([]);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    menu: null,
  });
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(hotelId);
  const [popUp, setPopUp] = useState(false);
  const [tempSearchText, setTempSearchText] = useState('');
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);

  const getCheckedMenuList = menuList?.filter((feed) => feed?.isChecked);
  const listOfIrdMenuIds = getCheckedMenuList?.map((feed) => feed.id);
  const selectedIRD_MENULength = getCheckedMenuList?.length;

  useEffect(() => {
    setMenuList((prevList) => {
      return inRoomDiningMenu?.map((ird) => {
        const isChecked = selectedCheckList(prevList, ird.id);
        return {
          ...ird,
          isChecked: isChecked,
        };
      });
    });
    setTempSearchText('');
  }, [inRoomDiningMenu]);

  useEffect(() => {
    if (inRoomDiningLoader || menuList?.length === 0) return;
    const totalItems = menuList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [menuList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const setSearchText = async (searchText) => {
    setTempSearchText(searchText);
    const checkedIdList = getCheckedIds(menuList, 'isChecked');
    const filteredRows = await inRoomDiningMenu.filter((menu) => {
      return menu.name.toLowerCase().includes(searchText.toLowerCase());
    });
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setMenuList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedIRD_MENULength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setMenuList(ResetFilterList);
    }
  };
  const dragDisabled = isDragDisabled(menuList, tempSearchText);

  const onClickAddMenu = () => {
    onViewToggle(IN_ROOM_DINING_MENU_CREATE_TYPE, true, null);
  };

  const onOpenDrawer = (event, type) => {
    if (selectedIRD_MENULength) {
      setMenuList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.menu);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      menu: null,
    });
  };

  const onClickRowViewDetails = (menuItem, e) => {
    if (e?.target?.tagName === 'TD') {
      (!isEmpty(menuItem.menuURL) || !isEmpty(menuItem.images)) &&
      menuItem?.categories?.length === 0
        ? onViewToggle(IN_ROOM_DINING_MENU_INFO_VIEW, true, menuItem)
        : onViewToggle(IN_ROOM_DINING_MENU_VIEW, true, menuItem);
    }
  };

  const onViewDetails = (menuItem) => {
    (!isEmpty(menuItem?.menuURL) || !isEmpty(menuItem?.images)) &&
    menuItem?.categories?.length === 0
      ? onViewToggle(IN_ROOM_DINING_MENU_INFO_VIEW, true, menuItem)
      : onViewToggle(IN_ROOM_DINING_MENU_VIEW, true, menuItem);
  };

  const handleEditDetails = (viewPage) => {
    onViewToggle(viewPage, true, selectedValue.menu);
  };

  const handleCellMenuClick = (event, menu) => {
    if (selectedIRD_MENULength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: menu.id,
        name: menu.name,
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        menu,
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onActiveDeActiveMenuItem = async (e) => {
    if (selectedValue.menu && hotelId) {
      try {
        dispatch(stepUpLoaderCount());
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        selectedValue.menu.isActive
          ? await deactiveInRoomDiningMenu(hotelId, restaurantId, selectedValue.id, language)
          : await activeInRoomDiningMenu(hotelId, restaurantId, selectedValue.id, language);
        handleClose();
        dispatch(fetchAllInRoomDiningMenu(hotelId, restaurantId));
        notificationManager(
          'success',
          `Menu ${selectedValue.menu.isActive ? 'draft' : 'published'} successfully`,
        );
      } catch (e) {
        if (e.graphQLErrors) {
          notificationManager('danger', e.graphQLErrors[0].message);
        } else {
          notificationManager('danger', 'Failed to update Menu status');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
      handleClose();
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onClickDelete = (event) => {
    setSelectedValue((prev) => ({
      ...prev,
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed',
      status: true,
      anchorEl: null,
    }));
  };

  const onDeleteMenuItem = async (e) => {
    if (hotelId && selectedValue.id) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        await deleteInRoomDiningMenu(hotelId, restaurantId, selectedValue.id, language);
        dispatch(fetchAllInRoomDiningMenu(hotelId, restaurantId));
        notificationManager('success', 'Menu deleted successfully');
      } catch (e) {
        if (e.graphQLErrors) {
          notificationManager('danger', e.graphQLErrors[0].message);
        } else {
          notificationManager('danger', 'Failed to delete Menu Menu');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
    handleClose();
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleSelectAll = (event) => {
    let selectedMenuList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedMenuList = menuList?.map((menu) => {
      return {
        ...menu,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedMenuList?.some((restaurant) => restaurant?.isActive);
    const isInactive = selectedMenuList?.some((restaurant) => !restaurant.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }

    setMenuList([...selectedMenuList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedMenuList?.some((menu) => menu?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const handleAction = (actionName) => {
    let selectedValue = menuList?.filter((SInfo) => SInfo?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedValue?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let actionList = [];
    let index = menuList?.findIndex((menu) => menu.id === id);
    if (!menuList[index]?.isChecked) {
      menuList[index] = { ...menuList[index], isChecked: true };
    } else {
      menuList[index].isChecked = !menuList[index]?.isChecked;
    }
    setMenuList([...menuList]);

    actionList = menuList?.filter((sInfo) => sInfo?.isChecked).map((status) => status?.isActive);

    const checkedItems = menuList?.filter((menu) => menu?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }

    const isAllSelected = menuList?.every((menu) => menu?.isChecked);
    setIsAllSelected(isAllSelected);
    if (!menuList[index].isChecked && !actionList?.some((menu) => menu?.isChecked)) {
      setActionMenuList([]);
    }

    setActionMenuList(actionListName);
  };

  const onApiCallConfirmationNotification = generatePublishedMessage(
    'Menu',
    listOfIrdMenuIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_MENU';
      await updateSelectedItemsStatus(
        listOfIrdMenuIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        isActive,
        tempSearchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDiningMenu(hotelId, restaurantId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'The status of the Menu was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setMenuList(ResetFilterList);
  };

  const deleteMultipleMenu = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_MENU';
      await deleteSelectedItems(
        listOfIrdMenuIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        tempSearchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDiningMenu(hotelId, restaurantId));
      notificationManager('success', 'Menus deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Menu',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
    setMenuList(ResetFilterList);
  };

  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setMenuList(
      inRoomDiningMenu.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
    setMenuList(ResetFilterList);
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDeleteMenuItem}
          onDeleteCancel={handleClose}
        />
      )}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedIRD_MENULength} ${
            selectedIRD_MENULength > 1 ? 'menus' : 'menu'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleMenu();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}

      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedIRD_MENULength}  ${
            selectedIRD_MENULength > 1 ? 'menus' : 'menu'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
      {showBulkSearchAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkSearchAlert}
          onClose={handleBulkSearchAlertClose}
          message="If you perform a search after making selections, the items you've selected will be lost."
          ButtonName='Cancel'
        />
      )}
      {showBulkKebabSelectionAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkKebabSelectionAlert}
          onClose={() => setShowBulkKebabSelectionAlert(false)}
          message='Please select one item from the list that you want to edit.'
          centerButtonName='OK'
        />
      )}
      <SearchBar
        type={IN_ROOM_DINING_MENU_CREATE}
        buttonName='Create Menu'
        setSearchText={setSearchText}
        onOpenDrawer={onClickAddMenu}
        displayAddOrEdit={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? !isHideAddButton
              ? 'show'
              : 'hide'
            : 'hide'
        }
        filterList={[]}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={menuList}
        setPlaceHolder={setMenuList}
        globalPlaceHolder={inRoomDiningMenu}
        setGlobalPlaceHolder={setInRoomDiningMenu}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='In-Room dining menu'
        module='IRD_MENU'
        searchText={tempSearchText}
        setSearch={setTempSearchText}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {inRoomDiningLoader && (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        )}
        <InRoomDiningMenuListTable
          page={page}
          inRoomDiningMenu={inRoomDiningMenu}
          rowsPerPage={rowsPerPage}
          onOpenDrawer={onOpenDrawer}
          onClickRowViewDetails={onClickRowViewDetails}
          onViewDetails={onViewDetails}
          selectedValue={selectedValue}
          handleClose={handleClose}
          handleCellMenuClick={handleCellMenuClick}
          menuList={menuList}
          setMenuList={setMenuList}
          permissions={permissions}
          handleChangePage={handleChangePage}
          onClickDeleteMenu={onClickDelete}
          onActiveDeActiveMenuItem={onActiveDeActiveMenuItem}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          setVisible={setVisible}
          onClickEditDetails={handleEditDetails}
          handleSelectAll={handleSelectAll}
          isAllSelected={isAllSelected}
          setIsAllSelected={setIsAllSelected}
          handleCheckboxChange={handleCheckboxChange}
          setActionMenuList={setActionMenuList}
          selectedIRD_MENULength={selectedIRD_MENULength}
          searchText={tempSearchText}
          dragDisabled={dragDisabled}
        />
      </div>
    </div>
  );
};

export default InRoomDiningMenuList;
